/**
 * Versión de Garaoke sincronizada con client/package.json
 */
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' 
  ? __APP_VERSION__ 
  : (import.meta.env?.VITE_APP_VERSION || '2.8.0');

/**
 * Genera el título estándar de la página concatenando la versión
 * @param {string} pageName Nombre de la vista (ej. "Garaoke", "Garaoke Player", "Garaoke Remote", "Garaoke Monitor")
 * @returns {string} Título formateado con la versión
 */
export const getAppTitle = (pageName = 'Garaoke') => {
  if (!pageName || pageName === 'Garaoke') {
    return `Garaoke v${APP_VERSION}`;
  }
  return `${pageName} v${APP_VERSION}`;
};
